import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../contexts/AuthenticationContext";
import { User } from "../../util/Interfaces";
import { confirmAlert } from "react-confirm-alert";
import ProjectElementService from "../../services/projectElement.service";
import ProjectTaskService from "../../services/projectTask.service";
import { ID_STATUS_CANCELED, ID_STATUS_COMPLETED, MIN_LEVEL_LEADER } from "../../util/Constants";
import {
  TextField, MenuItem, Stack, IconButton, Collapse, Typography,
  Menu, CircularProgress, ListItemIcon, ListItemText, Paper, SvgIcon,
  Select
} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { TrueffortButton, TrueffortChip, TrueffortTextField } from "../../MUIstyle/MUICustom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ProjectDetailPhaseRow from './ProjectDetailPhaseRow';
import { Delete as DeleteIcon, Edit as EditIcon, Close as CloseIcon, Save as SaveIcon } from '@mui/icons-material';
import { toast } from "react-toastify";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import { MeasurementsMenu } from "../estimation/EstimationPageUtils";
import PendingIcon from "@mui/icons-material/Pending";
import { dateToDateLocale, formatSeconds, statusAllowedSinceStatus } from "../../util/GlobalFunctions";
import { MeasurementsContext } from "./ProjectDetailContext";
import TrueffortChipStatus from "./TrueffortChipStatus";
import DatePicker from 'react-datepicker';
import { useState, useMemo } from "react";
import EstimationsService from "../../services/estimations.service";
import InteroperabilityService from "../../services/interoperabilty.service";

export type ElementType = {
  name: string,
  notes: string,
  duration: number,
  effort: number,
  registredDate: any,
};

// @ts-ignore
function ProjectDetailElementRow({ el, /*elementType,*/ users, idProject, states, _fillProjectInfo, 
project, tasks, priorityTypes, hasSecuency }:any) {
  const { t } = useTranslation();
  const { user } = useAuthContext() as { user: User };
  //console.log(el);
  const getHidePhaseAndTask = () => {
    if (el.phases.length == 1) {
      return el.phases[0].tasks.length == 1;
    }
    return false;
  }
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openOptions = Boolean(anchorEl);
  const [isEditing, setIsEditing] = useState(false);
  const projectElementService = useMemo(() => new ProjectElementService(), []);
  const projectTaskService = useMemo(() => new ProjectTaskService(), []);
  const estimationsService = useMemo(() => new EstimationsService(), []);
  const [showLoading, setShowLoading] = useState(false);
  const [openMeasurementsMenu, setOpenMeasurementsMenu] = useState(false);
  const [idSelectedStatus, setIdSelectedStatus] = useState(el.status_id);
  const [elementStatesAllowed, setElementStatesAllowed] = useState([]);
  const interoperabilityService = useMemo(() => new InteroperabilityService(), []);
  let hidePhaseAndTask = getHidePhaseAndTask();
  //console.log(hidePhaseAndTask);

  const handleClickOptions = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setAnchorEl(null);
  };

  const deleteProjectElement = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body custom-ui'>
            <h3 style={{ marginBottom: "1em" }}>{t("project_page.msg_delete_element_confirm2")} <span className="dark">{el.name + "?"}</span></h3>
            <p className="red"><strong>{t("project_page.msg_delete_element_confirm3")}</strong></p>
            <div className="react-confirm-alert-button-group">
              <button onClick={() => {
                setShowLoading(true);
                try {
                  // @ts-ignore
                  projectElementService.delete(el.id).then(({ data: response }) => {
                    toast.success(t("project_page.msg_success_element_delete"));
                    _fillProjectInfo();
                    setShowLoading(false);
                  }).catch(function (error: any) {
                    toast.error("Ocurrió un error al eliminar el elemento.");
                    setShowLoading(false);
                  });
                } catch (error) {
                  console.log("Error #Users handleDelete" + JSON.stringify(error));
                  toast.error("Ocurrió un error al eliminar la tarea.");
                  setShowLoading(false);
                }
                onClose();
              }}>
                {t("project_page.msg_delete_task_confirm_yes")}
              </button>
              <button onClick={onClose}>{t("project_page.msg_delete_task_confirm_no")}</button>
            </div>
          </div>
        );
      }
    });
  }

  const prepareEdit = (el: any) => {
    setAnchorEl(null);
    setIsEditing(true);
    let d = null;
    if (hidePhaseAndTask) {
      d = new Date(el.phases[0].tasks[0].registred_date);
      d.setHours(d.getHours() + 6);
    }
    setFormik({ values: { ...el, registredDate: d, notes: el.notes == 0 ? "" : el.notes }, errors: formik.errors });
    setElementStatesAllowed(statusAllowedSinceStatus({ status_id: el.status_id, status_name: el.status_name }));
  }

  const validate = (values: ElementType) => {
    //console.log(values);
    let errors: any = {};
    if (!values.name) {
      errors.name = "Required";
    }
    if (el.status_id != 4) {
      if (values.duration < 0) {
        errors.duration = t("project_tasks_page.msg.errors.duration_negative");
      }
    }

    if (values.effort < 0) {
      errors.effort = t("project_tasks_page.msg.errors.effort_negative");
    }

    if (new Date(values.registredDate) < new Date(project.registred_date)) {
      errors.registredDate = t("project_tasks_page.msg.errors.registred_date");
    }

    return errors;
  }

  const [formik, setFormik] = useState({
    values: {
      name: '', duration: el.name, notes: el.notes == '0' ? "" : el.notes,
      effort: el.effort, registredDate: hidePhaseAndTask ? new Date(el.phases[0].tasks[0].registred_date) : null
    },
    errors: { registredDate: null, duration: null, effort: null }
  });

  const handleSubmit = (values: any) => {
    let errors = validate(values);
    //console.log(errors);
    if (JSON.stringify(errors) != '{}') {
      setFormik({ values: formik.values, errors: errors });
      return;
    }
    //console.log(values);
    setAnchorEl(null);
    if (hidePhaseAndTask) {
      let projectTask = {
        idProjectTask: el.phases[0].tasks[0].id,
        name: '',
        registredDate: values.registredDate,
        status: {
          idStatus: idSelectedStatus
        },
        users: [],
        estimatedDays: values.duration,
        estimatedTime: values.effort,
        finishDate: [ID_STATUS_COMPLETED, ID_STATUS_CANCELED].includes(idSelectedStatus) ? dateToDateLocale(new Date()).toISOString() : null,
        projectPhase: {
          idProjectPhase: el.phases[0].id,
          projectElement: {
            idProjectElement: el.id,
            name: values.name,
            notes: values.notes,
            project: { idProject: idProject },
            estimatedDays: values.duration,
            estimatedTime: values.effort
          }
        }
      }
      projectTaskService.updateElementAsTask(projectTask.idProjectTask, projectTask).then(({ data: response }: any) => {
        if (response.internalError != null && response.internalError && response.message != null) {
          toast.error(response.message);
        } else {
          setFormik({
            values: {
              name: '', duration: el.name, notes: el.notes == '0' ? "" : el.notes,
              effort: el.effort, registredDate: new Date(el.phases[0].tasks[0].registred_date)
            },
            errors: { registredDate: null, effort: null, duration: null }
          });
          setIsEditing(false);
          toast.success(t("project_page.msg_success_pe_update"));
        }
        estimationsService.create().then(() => {
          _fillProjectInfo();
        });
        interoperabilityService.reviewProjectElementStatus(el.id).then(() => {});
      });
    } else {
      let elAux = {
        name: values.name,
        notes: values.notes,
        project: { idProject: idProject },
        estimatedDays: values.duration
      }
      // @ts-ignore
      projectElementService.updateName(el.id, elAux).then(({ data: response }) => {
        if (response.internalError != null && response.internalError && response.message != null) {
          toast.error(response.message);
        } else {
          setIsEditing(false);
          setFormik({
            values: {
              name: '', duration: el.name, notes: el.notes == '0' ? "" : el.notes,
              effort: el.effort, registredDate: null
            },
            errors: { registredDate: null, effort: null, duration: null }
          });
          toast.success(t("project_page.msg_success_pe_update"));
        }
        _fillProjectInfo();
        interoperabilityService.reviewProjectElementStatus(el.id).then(() => {});
      });
    }
  }

  const handleMeasurementsChange = (newSize: number, newComplexity: number, newFunctionalSize: number) => {
    const updatedProjectElem = {
      idSize: newSize,
      idComplexity: newComplexity,
      functionalSize: newFunctionalSize
    }

    // @ts-ignore
    projectElementService.updateMeasurements(el.id, updatedProjectElem).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
      } else {
        setIsEditing(false);
        toast.success(t("project_page.msg_success_pe_update"));
      }
    });
  }

  return (
    <>
      {!isEditing ?
        <Paper variant="outlined" square sx={{ padding: '3px' }} >
          <Grid container spacing={1} alignItems="center" >
            <Grid item xs={6} style={{padding:0, minHeight: '38px'}}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '700' }} >
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                </IconButton>
                {el.name}
              </Typography>
            </Grid>
            <Grid item xs={1.8} style={{padding:0, minHeight: el.name.length < 83 ? '38px' : 38 + ((el.name.length / 83) * 20), background:'#D7EBF0'}}><span>&nbsp;</span></Grid>
            <Grid item xs={1.83} style={{padding:0, minHeight: el.name.length < 83 ? '38px' : 38 + ((el.name.length / 83) * 20), background:'#CFF1AB'}}><span>&nbsp;</span></Grid>
            <Grid item xs={1.9} style={{padding:0, minHeight: el.name.length < 83 ? '38px' : 38 + ((el.name.length / 83) * 20), background:'#DFDFDF'}}><span>&nbsp;</span></Grid>
            <Grid item xs={0.47} />

            <Grid item xs={2} sx={{ display: "flex", justifyContent: 'center', paddingLeft:'30px' }} >
              <TrueffortChipStatus
                status_id={el.status_id}
                status_name={el.status_name}
              />
            </Grid>
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {hidePhaseAndTask ? el.phases[0].tasks[0].registred_date : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.start_date === 0 ? '------' : el.start_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.end_date === 0 ? '------' : el.end_date}
              </Typography>
            </Grid>

            <Grid item xs={1.01} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.estimated_finish_date === 0 ? '------' : el.estimated_finish_date}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background:'#D7EBF0', minHeight:'38px'}}>
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.duration?.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background:'#D7EBF0', minHeight:'38px'}}>
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {formatSeconds(el.effort * 3600, false, false, false)}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{padding:0, background: '#CFF1AB', minHeight:'38px'}}>
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.registered_duration?.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={0.92} style={{padding:0, background:'#CFF1AB', minHeight:'38px'}}>
              <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'column' }} >
                <span>{formatSeconds(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60, false, false, false)}</span>
                <span>{el.effort * 3600 == 0 ? "--" : ((el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) / (el.effort * 3600) * 100).toFixed(2) + '%'}</span>
              </Typography>
            </Grid>
            <Grid item xs={1} style={{background:'#DFDFDF', minHeight:'38px'}} >
              <Typography style={{fontWeight: 'bold'}} align="center" color={el.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem' }} >
                {Math.abs(el.days_deviation)}
              </Typography>
            </Grid>

            <Grid item xs={0.9} style={{background:'#DFDFDF', minHeight:'38px'}}>
              <Typography style={{fontWeight: 'bold'}} align="center" color={(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) == 0 ? '' : (el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) - (el.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem' }} >
                {(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) - (el.effort * 3600)), false, false, false)}
              </Typography>
            </Grid>

            <Grid item xs={0.47} >
              {!showLoading ?
                <>
                  {user.role.accessLevel >= MIN_LEVEL_LEADER &&
                    <Typography variant='subtitle2' color='#6693CB' align="center" 
                      onClick={handleClickOptions} style={{cursor: 'pointer'}}
                    >
                      <PendingIcon fontSize="small" />
                    </Typography>}
                  <Menu
                    id="basic-menu"
                    sx={{
                      '& .MuiPaper-root': {
                        backgroundColor: '#050536'
                      }
                    }}
                    anchorEl={anchorEl}
                    open={openOptions}
                    onClose={handleCloseOptions}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <MenuItem
                      onClick={() => prepareEdit(el)}
                    >
                      <ListItemIcon>
                        <EditIcon
                          size="small"
                          sx={{ color: '#F5F5F5' }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={{ color: '#F5F5F5' }}>
                        {t("elements.buttons.edit")}
                      </ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleCloseOptions();
                        setOpenMeasurementsMenu(true);
                      }}
                    >
                      <ListItemIcon>
                        <SquareFootIcon
                          size="small"
                          //className="color-red"
                          sx={{ color: '#F5F5F5' }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={{ color: '#F5F5F5' }} >
                        {t("estimation_page.measurements")}
                      </ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleCloseOptions();
                        deleteProjectElement();
                      }}
                    >
                      <ListItemIcon>
                        <DeleteIcon
                          size="small"
                          //className="color-red"
                          sx={{ color: '#989898' }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={{ color: '#989898' }} >
                        {t("delete")}
                      </ListItemText>
                    </MenuItem>
                  </Menu>
                </> : <CircularProgress size={15} />
              }
            </Grid>
            {el?.notes != 0 &&<> <Grid item xs={6}>
                <Typography sx={{ paddingLeft: '1.5em', fontSize: '0.75rem', fontWeight: '700' }} >
                  {el.notes}
                </Typography>
              </Grid>
              <Grid item xs={1.81} style={{padding:0, minHeight: el.notes.length < 83 ? '38px' : 38 + ((el.notes.length / 83) * 20), background:'#D7EBF0'}}><span>&nbsp;</span></Grid>
              <Grid item xs={1.82} style={{padding:0, minHeight: el.notes.length < 83 ? '38px' : 38 + ((el.notes.length / 83) * 20), background:'#CFF1AB'}}><span>&nbsp;</span></Grid>
              <Grid item xs={1.9} style={{padding:0, minHeight: el.notes.length < 83 ? '38px' : 38 + ((el.notes.length / 83) * 20), background:'#DFDFDF'}}><span>&nbsp;</span></Grid>
              <Grid item xs={0.47} />
            </>
            }
          </Grid>
        </Paper> :

        <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#DCDCDC' }} >
          <Grid container spacing={1} alignItems="center" >
            <Grid item xs={12} >
              <TextField
                id="idTxElementName"
                size="small"
                fullWidth
                variant="filled"
                sx={{ background: "white" }}
                placeholder={t("project_page.name_placeholder")}
                name="name"
                maxLength={500}
                onChange={(e: any) => setFormik({ values: { ...formik.values, name: e.target.value }, errors: formik.errors })}
                value={formik.values.name}
                error={formik.errors?.name && formik.touched?.name ? t(formik.errors.name) : null}
              />
            </Grid>

            {!hidePhaseAndTask ?
              <Grid item xs={2} sx={{ display: "flex", justifyContent: 'center' }} >
                <TrueffortChipStatus 
                  status_id={el.status_id}
                  status_name={el.status_name}
                />
              </Grid> :
              <Grid item xs={1.5} >
                <Select
                  fullWidth
                  id="idSlTaskStatus"
                  size="small"
                  name="idStatus"
                  onChange={(e: any) => setIdSelectedStatus(e.target.value)}
                  value={idSelectedStatus}
                >
                  {states?.map((ts: any, k: number) =>
                    <MenuItem
                      key={ts.idStatus}
                      disabled={typeof elementStatesAllowed.find((s: any) => s.idStatus == ts.idStatus) == "undefined"}
                      value={ts.idStatus}>
                      {ts.name}
                    </MenuItem>
                  )}
                </Select>
              </Grid>
            }
            {hidePhaseAndTask ? <Grid item xs={1.5}>
              <DatePicker
                style={{ width: '100%' }}
                dateFormat="yyyy/MM/dd"
                selected={formik?.values?.registredDate}
                onChange={(date: any) => setFormik({ values: { ...formik.values, registredDate: dateToDateLocale(date) }, errors: formik.errors })}
                customInput={<TrueffortTextField
                  size="small"
                  name="registredDate"
                  inputProps={{ background: 'red' }}
                  error={formik.errors.registredDate || ''}
                />}
              />
            </Grid> : <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {"N/A"}
              </Typography>
            </Grid>}
            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.start_date === 0 ? '------' : el.start_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.end_date === 0 ? '------' : el.end_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.estimated_finish_date === 0 ? '------' : el.estimated_finish_date}
              </Typography>
            </Grid>

            <Grid item xs={1} >
              <TextField
                name="duration" type="number" min="1"
                size="small"
                variant="filled"
                maxLength={6} disabled={el.status_id == 4}
                onChange={(e: any) => setFormik({ values: { ...formik.values, duration: e.target.value }, errors: formik.errors })}
                value={formik.values.duration}
                error={formik.errors?.duration && formik.touched?.duration ? t(formik.errors.duration) : null}
              />
            </Grid>

            {!hidePhaseAndTask ? <Grid item xs={1} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {formatSeconds(el.effort * 3600, false, false, false)}
              </Typography>
            </Grid> :
              <Grid item xs={1} >
                <TextField
                  name="effort"
                  type="number"
                  min="0"
                  size="small"
                  variant="filled"
                  label={t("estimation_page.effort_man_hours")}
                  maxLength={6} disabled={el.status_id == 4}
                  onChange={(e: any) => setFormik({ values: { ...formik.values, effort: e.target.value }, errors: formik.errors })}
                  value={formik.values.effort}
                  error={formik.errors?.effort && formik.touched?.effort ? t(formik.errors.effort) : null}
                />
              </Grid>

            }

            <Grid item xs={0.9} >
              <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                {el.registered_duration?.toLocaleString()}
              </Typography>
            </Grid>

            <Grid item xs={0.9} >
              <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'row' }} >
                <span>{formatSeconds(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60, false, false, false)}</span>
                <span>{el.effort * 3600 == 0 ? "--" : ((el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) / (el.effort * 3600) * 100).toFixed(2) + '%'}</span>
              </Typography>
            </Grid>
            <Grid item xs={0.9} >
              <Typography align="center" color={el.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                {Math.abs(el.days_deviation) }
              </Typography>
            </Grid>
            <Grid item xs={0.9}>
                <Typography style={{fontSize: '0.75rem', fontWeight:'bold'}} align="center" color={(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) == 0 ? '' : (el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) - (el.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem' }} >
                  {(el.registered_effort_hours * 3600 + el.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((el.registered_effort_hours * 3600 +
                    el.registered_effort_minutes * 60) - (el.effort * 3600)), false, false, false)}
                </Typography>
              </Grid>
            {formik.errors.duration && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formik.errors.duration}</Grid>}
            {formik.errors.effort && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formik.errors.effort}</Grid>}
            {formik.errors.registredDate && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>{formik.errors.registredDate + ' ' + project.registred_date}</Grid>}
            <Grid item xs={11} >
              <TextField
                id="idNotes"
                size="small"
                fullWidth
                variant="filled"
                sx={{ background: "white" }}
                placeholder={t('project_page.elem_notes_placeholder')}
                name="notes"
                maxLength={500}
                onChange={(e: any) => setFormik({ values: { ...formik.values, notes: e.target.value }, errors: formik.errors })}
                value={formik.values.notes}
              />
            </Grid>
            <Grid item xs={0.5} >
              <Stack direction="row" alignItems='center' >
                <TrueffortButton style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                  size="small"
                  color="primary"
                  id="idBtnEditElement"
                  aria-controls={openOptions ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openOptions ? 'true' : undefined}
                  onClick={() => handleSubmit(formik.values)}
                >
                  <SaveIcon />
                </TrueffortButton>
                <TrueffortButton style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                  size="small"
                  color="secondary"
                  id="btnOptionsElement"
                  aria-controls={openOptions ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openOptions ? 'true' : undefined}
                  onClick={() => {
                    setFormik({
                      values: {
                        name: '', duration: el.name, notes: el.notes == '0' ? "" : el.notes,
                        effort: el.effort, registredDate: hidePhaseAndTask ? new Date(el.phases[0].tasks[0].registred_date) : null
                      },
                      errors: { registredDate: null, effort: null, duration: null }
                    });
                    setIsEditing(false);
                  }}
                >
                  <CloseIcon />
                </TrueffortButton>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      }

      <MeasurementsMenu
        openState={{
          openMenu: openMeasurementsMenu,
          setOpenMenu: setOpenMeasurementsMenu
        }}
        size={el.size_id}
        complexity={el.complexity_id}
        functionalSize={1.00}
        handleMeasurementsChange={handleMeasurementsChange}
      />

      <Collapse in={open} timeout="auto" unmountOnExit>
        {!hidePhaseAndTask &&
          <Paper variant="outlined" square sx={{ padding: '4px', 
            backgroundColor: '#D7EBF0', borderBottomColor: '#D7EBF0', borderTopColor: '#D7EBF0',
            border: '1px solid rgba(0, 0, 0, 0.12)', borderTop: 0}} >
            <Grid container spacing={1} border={0} >
              <Grid item xs={6.01} style={{paddingLeft:'30px'}} >
                <Typography variant='caption' color={'#27535E'} sx={{ display: 'flex', alignItems: "center", fontWeight: '700' }} >
                  <SvgIcon sx={{ marginRight: '6px', width: "16px", height: "16px" }} >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none">
                      <g clipPath="url(#clip0_578_12469)">
                        <path d="M8.93752 7.79167C8.87794 7.79167 8.81835 7.79167 8.75877 7.81L8.02085 6.32042C8.18413 6.16122 8.2962 5.95692 8.3427 5.73367C8.38921 5.51041 8.36804 5.27836 8.2819 5.06721C8.19577 4.85605 8.04859 4.67541 7.8592 4.54838C7.6698 4.42136 7.44682 4.35373 7.21877 4.35417C7.15919 4.35417 7.10419 4.35417 7.04002 4.3725L6.29294 2.88292C6.51294 2.67667 6.64585 2.38792 6.64585 2.0625C6.64585 1.75861 6.52513 1.46716 6.31025 1.25227C6.09536 1.03739 5.80391 0.916667 5.50002 0.916667C5.19613 0.916667 4.90468 1.03739 4.68979 1.25227C4.47491 1.46716 4.35419 1.75861 4.35419 2.0625C4.35419 2.38792 4.4871 2.67667 4.70252 2.88292L3.96002 4.3725C3.89585 4.35417 3.84085 4.35417 3.78127 4.35417C3.55323 4.35373 3.33024 4.42136 3.14084 4.54838C2.95145 4.67541 2.80427 4.85605 2.71814 5.06721C2.632 5.27836 2.61083 5.51041 2.65734 5.73367C2.70384 5.95692 2.81591 6.16122 2.97919 6.32042L2.24127 7.81C2.18169 7.79167 2.1221 7.79167 2.06252 7.79167C1.75863 7.79167 1.46718 7.91239 1.25229 8.12727C1.03741 8.34216 0.916687 8.63361 0.916687 8.9375C0.916687 9.24139 1.03741 9.53284 1.25229 9.74773C1.46718 9.96261 1.75863 10.0833 2.06252 10.0833C2.21299 10.0833 2.36199 10.0537 2.50101 9.99611C2.64003 9.93853 2.76635 9.85413 2.87275 9.74773C2.97915 9.64133 3.06355 9.51501 3.12113 9.37599C3.17872 9.23697 3.20835 9.08797 3.20835 8.9375C3.20835 8.61667 3.07544 8.32333 2.86002 8.11708L3.60252 6.6275C3.66669 6.64583 3.72169 6.64583 3.78127 6.64583C3.84085 6.64583 3.89585 6.64583 3.96002 6.6275L4.7071 8.11708C4.49169 8.32333 4.35419 8.61667 4.35419 8.9375C4.35419 9.24139 4.47491 9.53284 4.68979 9.74773C4.90468 9.96261 5.19613 10.0833 5.50002 10.0833C5.80391 10.0833 6.09536 9.96261 6.31025 9.74773C6.52513 9.53284 6.64585 9.24139 6.64585 8.9375C6.64585 8.63361 6.52513 8.34216 6.31025 8.12727C6.09536 7.91239 5.80391 7.79167 5.50002 7.79167C5.44044 7.79167 5.38085 7.79167 5.32127 7.81L4.58335 6.32042C4.79419 6.11417 4.9271 5.82542 4.9271 5.5C4.9271 5.17458 4.79419 4.88583 4.58335 4.67958L5.32127 3.19C5.38085 3.20833 5.44044 3.20833 5.50002 3.20833C5.5596 3.20833 5.61919 3.20833 5.67877 3.19L6.41669 4.67958C6.21044 4.88583 6.07294 5.17917 6.07294 5.5C6.07294 5.80389 6.19366 6.09534 6.40854 6.31023C6.62343 6.52511 6.91488 6.64583 7.21877 6.64583C7.27835 6.64583 7.33335 6.64583 7.39752 6.6275L8.1446 8.11708C7.92919 8.32333 7.79169 8.61667 7.79169 8.9375C7.79169 9.24139 7.91241 9.53284 8.12729 9.74773C8.34218 9.96261 8.63363 10.0833 8.93752 10.0833C9.24141 10.0833 9.53286 9.96261 9.74775 9.74773C9.96263 9.53284 10.0834 9.24139 10.0834 8.9375C10.0834 8.63361 9.96263 8.34216 9.74775 8.12727C9.53286 7.91239 9.24141 7.79167 8.93752 7.79167Z" fill="#27535E" />
                      </g>
                      <defs>
                        <clipPath id="clip0_578_12469">
                          <rect width="11" height="11" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </SvgIcon>
                  {t("home.phases")}
                </Typography>
              </Grid>
              <Grid item xs={1.8} style={{background:'#D7EBF0', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.83} style={{background:'#CFF1AB', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.9} style={{background:'#DFDFDF', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={0.46} style={{background:'white', minHeight:'32px', marginTop: '-1px'}}></Grid>
            </Grid>
          </Paper>
        }

        <MeasurementsContext.Provider
          value={{
            idSize: el.size_id,
            idComplexity: el.complexity_id
          }}
        >
          {el.phases.map((ph: any, k: number) => (
            <ProjectDetailPhaseRow
              key={ph.id}
              el={el}
              phase={ph}
              users={users}
              states={states}
              _fillProjectInfo={_fillProjectInfo}
              hidePhaseAndTask={hidePhaseAndTask}
              project={project}
              tasks={tasks}
              priorityTypes={priorityTypes}
              hasSecuency={hasSecuency}
            />
          ))}
        </MeasurementsContext.Provider>
      </Collapse>
    </>
  );
}

export default ProjectDetailElementRow;